import React from "react";
import { TOOLS, EMOJI_SET } from "../../engine";
import { TOOL_ICONS, TOOL_SHORTCUTS, UI } from "../../design/icons/ChartIconRegistry";

const CURSOR_LABELS = { select: "Arrow (select)", cross: "Crosshair", dot: "Dot", eraser: "Eraser" };
export const toolLabel = (id) => TOOLS[id]?.label ?? CURSOR_LABELS[id] ?? id;

// Flyout listing every tool of a category: icon · label · shortcut · favourite star. Emoji tool expands into a sticker grid.
export default function ToolFlyout({ category, active, favorites, onToggleFavorite, onPick }) {
  const Star = UI.star;
  return (
    <div className="w-72 py-1" data-testid={`tool-flyout-${category.id}`}>
      <div className="px-3 py-1.5 text-[10px] uppercase tracking-widest text-muted-foreground flex items-center justify-between">
        <span>{category.label}</span>
        <span className={`text-[9px] ${category.layer === "felacoo" ? "text-primary" : ""}`}>{category.layer === "felacoo" ? "Fela R.I.O native" : `${category.tools.length} tools`}</span>
      </div>
      {category.tools.map((id) => {
        const Icon = TOOL_ICONS[id];
        const on = active === id, fav = favorites.includes(id);
        return (
          <div key={id} className={`group flex items-center gap-2 px-2 h-8 mx-1 rounded-md ${on ? "bg-primary/15 text-primary" : "hover:bg-secondary"}`}>
            <button data-testid={`draw-tool-${id}`} onClick={() => onPick(id)} className="flex-1 flex items-center gap-2.5 text-left text-xs">
              {Icon && <Icon size={16} stroke={1.7} className="shrink-0" />}
              <span className="truncate">{toolLabel(id)}</span>
              {TOOLS[id]?.variable && <span className="text-[9px] text-muted-foreground">dbl-click to finish</span>}
              {TOOLS[id]?.freehand && <span className="text-[9px] text-muted-foreground">drag</span>}
            </button>
            {TOOL_SHORTCUTS[id] && <kbd className="text-[9px] font-mono text-muted-foreground border border-border rounded px-1">{TOOL_SHORTCUTS[id]}</kbd>}
            <button data-testid={`draw-fav-${id}`} title={fav ? "Remove from favourites" : "Add to favourites"} onClick={() => onToggleFavorite(id)}
              className={`h-6 w-6 flex items-center justify-center rounded ${fav ? "text-primary" : "text-muted-foreground opacity-0 group-hover:opacity-100"}`}>
              <Star size={13} weight={fav ? "fill" : "regular"} />
            </button>
          </div>
        );
      })}
      {category.tools.includes("emoji") && (
        <div className="mx-2 mt-1 pt-2 border-t border-border">
          <div className="text-[10px] uppercase tracking-widest text-muted-foreground px-1 pb-1">Stickers · Twemoji</div>
          <div className="grid grid-cols-8 gap-0.5" data-testid="emoji-grid">
            {EMOJI_SET.map((em) => (
              <button key={em} data-testid={`emoji-${em.codePointAt(0).toString(16)}`} onClick={() => onPick("emoji", { emoji: em })} className="h-7 rounded hover:bg-secondary text-base leading-none">{em}</button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
